<div
  class="w-full relative rounded-lg border border-gray-200 box-content overflow-hidden"
  [ngClass]="{ 'h-full overflow-auto': scroll }"
  (wheel)="onScroll($event)"
>
  @if (_tableWidth != null && lockedTableWidth != null && tableBody == null) {
    <div
      class="absolute h-full right-0 top-0 z-30"
      [style.width.%]="lockedTableWidth"
    >
      <div class="w-full h-full relative">
        <div class="absolute top-0 left-0">
          <table
            class="w-full divide-y divide-gray-200 table-fixed border-gray-200 border-b border-l"
          >
            <thead class="bg-gray-50">
              <tr>
                <ng-template
                  [ngTemplateOutlet]="tableHeader || defaultTableHeader"
                  [ngTemplateOutletContext]="{
                    cols: lockedHeader,
                  }"
                />
              </tr>
            </thead>
          </table>
        </div>
        <div #lockedTableRow class="w-full h-full overflow-y-hidden">
          <table
            class="w-full divide-y divide-gray-200 table-fixed border-gray-200 border-b border-l"
          >
            <thead class="bg-gray-50 opacity-0">
              <tr>
                <ng-template
                  [ngTemplateOutlet]="tableHeader || defaultTableHeader"
                  [ngTemplateOutletContext]="{
                    cols: lockedHeader,
                  }"
                />
              </tr>
            </thead>
            <tbody>
              @if (tableBody == null) {
                @for (row of _rows; track row.id; let i = $index) {
                  <tr
                    [style.height.px]="lockedTableRowHeight - 1"
                    class="bg-white"
                    [ngClass]="{
                      'bg-white': i % 2 === 0,
                      'bg-gray-50': i % 2 === 1,
                    }"
                  >
                    <ng-template
                      [ngTemplateOutlet]="tableContent || defaultTableContent"
                      [ngTemplateOutletContext]="{
                        row: row,
                        cols: lockedHeader,
                      }"
                    />
                  </tr>
                }
              }
            </tbody>
            @if (this.loading) {
              <div
                class="w-full flex items-center justify-center py-5 opacity-0"
              >
                <confect-spinner [show]="true" />
              </div>
            }
          </table>
        </div>
      </div>
    </div>
  }
  @if (tableToolBar != null) {
    <div class="w-full bg-white p-2 border-b border-gray-200">
      <ng-template
        [ngTemplateOutlet]="tableToolBar"
        [ngTemplateOutletContext]="{}"
      />
    </div>
  }
  <div
    #tableFixedBox
    class="relative w-full"
    [ngClass]="{ 'h-full overflow-x-auto': scroll }"
  >
    @if (scroll) {
      <div
        class="absolute top-0 left-0 z-20"
        [style.width.%]="_tableWidth ?? 100"
      >
        <table
          class="w-full divide-y divide-gray-200 table-fixed border-gray-200 border-b"
        >
          <thead class="bg-gray-50">
            <tr>
              <ng-template
                [ngTemplateOutlet]="tableHeader || defaultTableHeader"
                [ngTemplateOutletContext]="{
                  cols: _header,
                }"
              />
            </tr>
          </thead>
        </table>
      </div>
    }

    <div
      #tableBox
      class="h-full relative"
      [style.width.%]="_tableWidth ?? 100"
      [ngClass]="{ 'overflow-y-hidden': scroll }"
    >
      <table #table class="w-full divide-y divide-gray-200 table-fixed">
        <thead class="bg-gray-50" [ngClass]="{ 'opacity-0': scroll }">
          <tr>
            <ng-template
              [ngTemplateOutlet]="tableHeader || defaultTableHeader"
              [ngTemplateOutletContext]="{
                cols: _header,
              }"
            />
          </tr>
        </thead>
        <tbody>
          @if (tableBody != null) {
            <ng-template
              [ngTemplateOutlet]="tableBody"
              [ngTemplateOutletContext]="{
                rows: _rows,
                cols: _header,
              }"
            />
            @if (_rows.length === 0 && !loading) {
              <tr>
                <td
                  [attr.colspan]="_header.length"
                  class="py-3 text-lg text-gray-400"
                >
                  <div class="w-full flex items-center justify-center">
                    {{ emptyState }}
                  </div>
                </td>
              </tr>
            }
          } @else {
            @if (_rows.length === 0 && !loading) {
              <tr>
                <td
                  [attr.colspan]="_header.length"
                  class="py-3 text-lg text-gray-400"
                >
                  <div class="w-full flex items-center justify-center">
                    {{ emptyState }}
                  </div>
                </td>
              </tr>
            }
            @for (row of _rows; track row.id; let i = $index) {
              <tr
                #tableRow
                class="bg-white"
                [ngClass]="{
                  'bg-white': i % 2 === 0,
                  'bg-gray-50': i % 2 === 1,
                }"
              >
                <ng-template
                  [ngTemplateOutlet]="tableContent || defaultTableContent"
                  [ngTemplateOutletContext]="{
                    row: row,
                    cols: _header,
                  }"
                />
              </tr>
            }
          }
        </tbody>
      </table>
      @if (this.loading) {
        <div class="w-full flex items-center justify-center py-5">
          <confect-spinner [show]="true" />
        </div>
      }
    </div>
  </div>
</div>

<ng-template #defaultTableContent let-row="row" let-cols="cols">
  @for (col of cols; track col) {
    <td
      [title]="row[col.key]"
      class="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-700 text-ellipsis truncate"
    >
      {{ row[col.key] }}
    </td>
  }
</ng-template>

<ng-template #defaultTableHeader let-cols="cols">
  @for (col of cols; track col) {
    <th
      scope="col"
      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      [style.width.%]="col.size * 100"
    >
      {{ col.name }}
    </th>
  }
</ng-template>
